import { Tab } from '../Tab';
import { TabButton } from '../TabButton';
import { TabsContainer } from '../TabsContainer';
import { StyledMenuContainer } from './MenuTabs.styled';

const MenuTabs = () => (
	<StyledMenuContainer>
		<TabButton>Q</TabButton>
		<TabsContainer>
			<Tab>Настройки</Tab>
			{/* <Tab>Сеть</Tab> */}
			<Tab>Сохраненные</Tab>
		</TabsContainer>
		<TabButton>E</TabButton>
	</StyledMenuContainer>
);

export { MenuTabs };
